import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useTranslation } from '@/hooks/useTranslation'

type TimePeriod = 'all' | 'week' | 'month' | 'year'

interface TimePeriodSelectorProps {
	selectedPeriod: TimePeriod
	onChange: (period: TimePeriod) => void
	className?: string
}

const TimePeriodSelector = ({
	selectedPeriod,
	onChange,
	className,
}: TimePeriodSelectorProps) => {
	const { t } = useTranslation()
	const periods: { label: string; value: TimePeriod }[] = [
		{ label: t('timePeriodSelector.all'), value: 'all' },
		{ label: t('timePeriodSelector.week'), value: 'week' },
		{ label: t('timePeriodSelector.month'), value: 'month' },
		{ label: t('timePeriodSelector.year'), value: 'year' },
	]

	return (
		<div
			className={cn(
				'inline-flex items-center rounded-lg bg-muted p-1 dark:bg-slate-800 shadow-inner',
				className
			)}>
			{periods.map((period) => (
				<Button
					key={period.value}
					variant={selectedPeriod === period.value ? 'secondary' : 'ghost'}
					size="sm"
					onClick={() => onChange(period.value)}
					className={cn(
						'px-3 py-1 h-8 transition-colors duration-200 ease-in-out',
						selectedPeriod === period.value
							? 'bg-background shadow-sm text-foreground'
							: 'text-muted-foreground hover:text-foreground'
					)}>
					{period.label}
				</Button>
			))}
		</div>
	)
}

export default TimePeriodSelector
